import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.232 10.83.53-.53-1.589-1.588-2.91-2.911-1.59-1.59-.53.53-1.059 1.06-9.338 9.337a4.16 4.16 0 0 0-1.04 1.753l-1.66 5.644c-.117.394-.009.82.286 1.111.296.29.718.398 1.111.286l5.64-1.66a4.16 4.16 0 0 0 1.753-1.04l9.337-9.337zM7.5 18.725l-.427 1.064a2 2 0 0 1-.623.324L2.784 21.19l1.078-3.661c.066-.23.178-.44.324-.623l1.064-.427v1.5c0 .412.337.75.75.75h1.5zM17 .88l-.675.68-1.06 1.059-.534.53 1.59 1.589 2.91 2.91 1.59 1.59.53-.53 1.058-1.06.68-.679a3 3 0 0 0 0-4.242L21.248.879a3 3 0 0 0-4.242 0zm-2.22 7.874-6.75 6.75a.753.753 0 0 1-1.06 0 .753.753 0 0 1 0-1.06l6.75-6.75a.753.753 0 0 1 1.06 0c.29.291.29.77 0 1.06"
    }, null, -1)
  ]))]))
}
export default { render: render }